import { Stack, Typography } from '@mui/material';
import React from 'react';

function TimelineInstructions() {
  return (
    <Stack direction="row" spacing={2}>
      <Typography variant="body2" fontWeight={'bold'} color={'#333'}>
        <span style={{ color: 'firebrick', fontWeight: '600' }}>SHIFT + MOUSEWHEEL DOWN</span> = SCROLL RIGHT
      </Typography>

      <Typography variant="body2" fontWeight={'bold'} color={'#333'}>
        <span style={{ color: '#1B558E', fontWeight: '600' }}>SHIFT + MOUSEWHEEL UP</span> = SCROLL LEFT
      </Typography>
    </Stack>
  );
}

export default TimelineInstructions;
